import * as $ from "jquery";

declare var toastr: any;
declare var jQuery: any;
declare var $: any;
declare var Clipboard: any;

export class Helpers {
	static setLoading(loading) {
		let body = $('body');
		if (loading) {
			$('.preloader-backdrop').fadeIn(200);
		} else {
			$('.preloader-backdrop').fadeOut(200);
		}
	}

	static bodyClass(Class) {
		$('body').attr('class', Class);
	}

	static initLayout() {
		// SIDEBAR ACTIVATE METISMENU
		$(".metismenu").metisMenu();

		// SIDEBAR TOGGLE ACTION
		$('.js-sidebar-toggler').click(function () {
			if ($('body').hasClass('drawer-sidebar')) {
				$('#sidebar').backdrop();
			} else {
				$('body').toggleClass('sidebar-mini');

				if (!$('body').hasClass('sidebar-mini')) {
					$('#sidebar-collapse').hide();
					$('.side-popup').css({
						'top': '60px',
						'left': '230px'
					});
					setTimeout(function () {
						$('#sidebar-collapse').fadeIn(300);
					}, 200);
				}
				else {
					$('.side-popup').css({
						'top': '60px',
						'left': '70px'
					});
				}
			}
		});
	}

	static initPage() {

		// Activate fixed layout
		$('#sidebar-collapse').slimScroll({
			height: '100%',
			railOpacity: '0.9',
		});

		// Activate slimscroll
		$('.scroller').each(function () {
			$(this).slimScroll({
				height: $(this).attr('data-height') || '100%',
				color: $(this).attr('data-color') || '#71808f',
				railOpacity: '0.9',
				size: '4px',
			});
		});

		$('.slimScrollBar').hide();

		// Pre Copy to clipboard

		if ($(".clipboard-copy").length > 0) {
			new Clipboard('.clipboard-copy', {
				target: function (t) {
					return t.nextElementSibling;
				}
			}).on('success', function (e) {
				e.clearSelection();
				e.trigger.textContent = 'Copied';
				window.setTimeout(function () {
					e.trigger.textContent = 'Copy';
				}, 2000);
			});
		}

	}

	static pageResponsive() {
			$('body').addClass('drawer-sidebar');
			$('#sidebar-collapse').slimScroll({
					height: '100%',
					railOpacity: '0.9',
			});

			$('body').removeClass('has-backdrop');
			$('.shined').removeClass('shined');
	}
}
